import styled from 'styled-components';
import React, { useState } from 'react';
import theme from '../../UI/theme';

const DotsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 0px;
`

const Dot = styled.div`
    height: 8px;
    width: 8px;
    background-color: ${props => props.active ? theme.colors.greenEnergy : theme.colors.textGray};
    border-radius: 50%;
    margin: 0 8px;
`

const ProgressDots = ({ total, current }) => {
    return <DotsContainer>
        {Array.from({length: total}, (_, i) => i + 1).map(i => <Dot key={i} active={i <= current} />)}
    </DotsContainer>
}

export default ProgressDots;

